// extracted by mini-css-extract-plugin
export var container = "_q4-0";
export var table = "_q4-2";
export var tableWrapper = "_q4-1";